export default (func) => {
  const nextResize = () => {
    func();
    window.removeEventListener('resize', nextResize);
  };

  window.addEventListener('resize', nextResize);
}
